import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { NavigateRoutes, RequestType } from 'common/constants/app.constant';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { CustomError } from './error';
import { HttpService } from 'common/services/core_services/http.service';
import { environment } from 'common/environment/environment.dev';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private injector: Injector) { }

    handleError(error: any): void {
        const router = this.injector.get(Router);

        const resp = async () => {
            return await this.sendErrorToCloud(error);
        };
        resp();
        if (error instanceof CustomError && error.errorCode === 'INVALID_ENCRYPT') {
            localStorage.clear();
            const routeMsg = new RouteMessage();
            routeMsg.type = RequestType.BLANK;
            routeMsg.transferData = null;
            router.navigate(NavigateRoutes.loginarn as any, { state: routeMsg, replaceUrl: true });
        }
    }

    async sendErrorToCloud(err: any) {
        const errorDetails = {
            message: err.message || 'Unknown error',
            stack: err.stack || 'No stack trace available',
            timestamp: new Date().toISOString(),
        };
        const prepareErrObj = {
            type: '',
            appId: '',
            module: err.module,
            timestamp: '',
            error_log: JSON.stringify(errorDetails),
            ip: '',
        };
        const httpService = this.injector.get(HttpService);
        try {
            const response = await httpService.postUrlToError(environment.cloudErrUrl, prepareErrObj);
        } catch (exp) {
            console.log(exp);
        }
    }
}